import { CenterOlPaymentStatusEnum } from '../../types/enums/center-ol-payment/center-ol-payment-status.enum'
import { CenterOlPaymentTypeEnum } from '../../types/enums/center-ol-payment/center-ol-payment-type.enum'
import { CurrencyEnum } from '../../types/enums/common/currency.enum'
import { OLTypeEnum } from '../../types/enums/ol/ol-type.enum'
import { CenterOlPaymentFilters } from '../../types/models/center-ol-payment/center-ol-payment'

export const transformCenterOlPaymentFiltersToUrl = (filters?: CenterOlPaymentFilters): string => {
  if (!filters) return ''
  const searchParams = new URLSearchParams()

  if (filters.centerId) searchParams.append('centerId', filters.centerId.toString())

  if (filters.olId) searchParams.append('olIds', filters.olId.toString())

  if (filters.olTypes && filters.olTypes.length)
    searchParams.append('olType', filters.olTypes.join(','))

  if (filters.status) searchParams.append('status', filters.status)

  if (filters.type) searchParams.append('type', filters.type)

  if (filters.countryIds && filters.countryIds.length)
    searchParams.append('countryIds', filters.countryIds.join(','))

  if (filters.formulaIds && filters.formulaIds.length)
    searchParams.append('formulaIds', filters.formulaIds.join(','))

  if (filters.periodIds && filters.periodIds.length)
    searchParams.append('periodIds', filters.periodIds.join(','))

  if (filters.currency) searchParams.append('currency', filters.currency)

  if (filters.hasInvoices !== undefined)
    searchParams.append('hasInvoices', filters.hasInvoices.toString())

  if (filters.dateOfPayment) searchParams.append('dateOfPayment', filters.dateOfPayment)

  return searchParams.toString()
}

export const transformUrlToCenterOlPaymentFilters = (
  searchParams: URLSearchParams
): CenterOlPaymentFilters => {
  const filters: CenterOlPaymentFilters = {}

  const centerId = searchParams.get('centerId')
  if (centerId) filters.centerId = parseInt(centerId, 10)

  const olId = searchParams.get('olId')
  if (olId) filters.olId = parseInt(olId, 10)

  const olTypes = searchParams.get('olTypes')
  if (olTypes) filters.olTypes = olTypes.split(',') as OLTypeEnum[]

  const status = searchParams.get('status')
  if (status) filters.status = status as CenterOlPaymentStatusEnum

  const type = searchParams.get('type')
  if (type) filters.type = type as CenterOlPaymentTypeEnum

  const countryIds = searchParams.get('countryIds')
  if (countryIds) filters.countryIds = countryIds.split(',').map((id) => parseInt(id, 10))

  const formulaIds = searchParams.get('formulaIds')
  if (formulaIds) filters.formulaIds = formulaIds.split(',').map((id) => parseInt(id, 10))

  const periodIds = searchParams.get('periodIds')
  if (periodIds) filters.periodIds = periodIds.split(',').map((id) => parseInt(id, 10))

  const currency = searchParams.get('currency')
  if (currency) filters.currency = currency as CurrencyEnum

  const hasInvoices = searchParams.get('hasInvoices')
  if (hasInvoices) filters.hasInvoices = hasInvoices === 'true'

  const dateOfPayment = searchParams.get('dateOfPayment')
  if (dateOfPayment) filters.dateOfPayment = dateOfPayment

  return filters
}
